export const green600 = "#26ad2bff"; // success
export const green700 = "#1f8c24"; // success hover

export const blue900 = "#003350"; // neutral
export const blue600 = "#123072"; // neutral hover
export const darkBlue800 = "#002635"; // neutral hover

export const red500 = "#EF4444"; // error
export const red600 = "#e53b3b"; // error hover

export const white = "#ffffff";

//Gray colors
export const gray400 = "rgba(107,114,128,0.4)"; // border gray
export const gray50 = "#f8fafc"; // outline hover
export const lightGray = "#6A7282";

export const red700 = "#E7000B"; // outline-error text
// outline-error background
export const RGBA_ERROR_BORDER = "rgba(239,68,68,0.4)";

export const pink900 = "#9333EA";
export const pink50 = "#F3E8FF";

export const purple900 = "#9316A3";
export const purple50 = "#FCDCEF";

export const orange900 = "#EA580C";
export const orange50 = "#FFEDD5";

export const textGray = "#BEDBFF";

export const darkBlue = "#101828";
